import get from 'lodash/get';
import mint from '@tunein/mint';
import viewTypes from '../constants/unlock/viewTypes';
import {
  NEEDS_UNLOCK_DIALOG,
  UNLOCK_SUCCESS,
  UNLOCK_FAILURE,
  UNLOCK_CREDIT,
  UNLOCK_CLOSED,
  UNLOCK_UPDATE_DIALOG_DIMENSIONS,
} from '../actions/unlock';
import createMappedReducer from './utils/createMappedReducer';
import { fulfilled, rejected } from './utils/asyncActionNameSuffixes';

const initialState = {
  unlockDialogOpen: false,
  unlockDialogWidth: 960,
  unlockDialogHeight: 540,
  viewType: viewTypes.unlockActivity,
  isCreditUnlocked: false,
  unlockFailed: false,
  unlockFailedError: '',
};

export const unlockDetails = createMappedReducer(initialState, {
  [NEEDS_UNLOCK_DIALOG](state, action) {
    return {
      ...state,
      unlockDialogOpen: true,
      viewType: viewTypes.unlockActivity,
      unlockDialogWidth: 960,
      unlockDialogHeight: 540,
      campaignId: action.campaignId,
      campaignKey: action.campaignKey,
      unlockToken: action.unlockToken,
      isCreditUnlocked: false,
    };
  },
  [UNLOCK_SUCCESS](state) {
    return {
      ...state,
      unlockDialogOpen: true,
      viewType: viewTypes.unlockSuccess,
      unlockDialogWidth: 300,
      unlockDialogHeight: undefined,
      campaignKey: null,
      unlockToken: null,
    };
  },
  [fulfilled(UNLOCK_CREDIT)](state, action) {
    mint.updateUnlockDetails(action.payload);
    return {
      ...state,
      unlockDialogOpen: true,
      secondsRemaining: get(action, 'payload.SecondsRemaining'),
      actionGuideId: get(action, 'payload.UnlockActionGuideId'),
      isCreditUnlocked: true,
    };
  },
  [rejected(UNLOCK_CREDIT)](state, action) {
    return {
      ...state,
      unlockFailed: true,
      unlockFailedError: get(action, 'payload.message', ''),
    };
  },
  [UNLOCK_FAILURE](state) {
    return {
      ...state,
      unlockDialogOpen: true,
      viewType: viewTypes.unlockFailure,
      unlockDialogWidth: 300,
      unlockDialogHeight: undefined,
      campaignKey: null,
      unlockToken: null,
    };
  },
  [UNLOCK_CLOSED](state) {
    return {
      ...state,
      unlockDialogOpen: false,
      viewType: null,
    };
  },
  [UNLOCK_UPDATE_DIALOG_DIMENSIONS](state, action) {
    return {
      ...state,
      unlockDialogWidth: action.width,
      unlockDialogHeight: action.height,
    };
  },
});
